import servicesUtils from "../../../utils/servicesUtils";
var markNotificationsRead = function markNotificationsRead(params) {
  return servicesUtils.postService("/notifications/mark-read/", params);
};
export default markNotificationsRead;